
export const transformTextWithNewLine = (value?: string | null) => {
    if(!value) return '';
    return value.replace(/(?:\\r\\n|\\r|\\n|<br\s*[/]?>)/g, '\r\n')
};
